// @flow
import { handleActions } from 'redux-actions';
import { UPDATE_DOCUMENT_TITLE } from './constants';

export type State = {
    documentTitle: string,
};

const initialState: State = {
    documentTitle: '',
};

const reducer = handleActions({
    [UPDATE_DOCUMENT_TITLE]: (state: State, { payload }: {
        payload: string,
    }) => ({
        documentTitle: payload,
    }),
}, initialState);

export default reducer;
